import ShortenedTitle from "components/General-UI/ShortenedTitle";
import Modal from "components/HOCS/Modal";
import { nameThisId } from "helpers/efficeHelpers";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectData } from "slices/efficeCacheSlice";
import {
  resetAppModal,
  selectAppModalNodeId,
  selectAppModalAppId,
} from "slices/generalSlice";
import NewAppForm from "./NewAppForm/NewAppForm";

const NewAppModal = () => {
  const dispatch = useDispatch();
  const appModalNode = useSelector(
    (state) => selectData(state)[selectAppModalNodeId(state)]
  );
  const appModalAppId = useSelector(selectAppModalAppId);

  const [priv, setPriv] = useState(false);
  const changePrivate = useCallback((val) => {
    setPriv(val);
  }, []);

  if (!appModalNode || appModalAppId == null) return null;
  return (
    <Modal
      growth={false}
      noBackDropClick={false}
      lightBackDrop={!priv}
      header={
        <>
          Add A {nameThisId(appModalAppId)} to&nbsp;
          <ShortenedTitle title={appModalNode.content} maxChars={100} />
        </>
      }
      content={
        <NewAppForm
          priv={priv}
          setPriv={changePrivate}
          appModalNode={appModalNode}
          appModalAppId={appModalAppId}
          onDismiss={() => dispatch(resetAppModal())}
        />
      }
      onDismiss={() => dispatch(resetAppModal())}
    />
  );
};

export default NewAppModal;
